export default {
  dynamics: '{{change}} vs {{time_unit}} anterior',
};
